import { CModal, CModalBody } from '@coreui/react'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import CarbonEmissionComponent from 'src/components/DashboardComponents/CarbonEmissionComponent/CarbonEmissionComponent'
import styles from './carbonEmissionsReportComponent.module.scss'

const getAccountName = (contactList, viewAccount) => {
  if (!contactList?.length || !viewAccount) return ''
  const contact = contactList.find(
    (contact) => contact.fruitful_account_id === viewAccount.fruitful_account_id,
  )
  if (!contact) return ''
  return `${contact.firstname} ${contact.lastname}`
}

const CarbonEmissionsReportComponent = ({
  viewAccount,
  contactList,
  openCarbonReport,
  setOpenCarbonReport,
}) => {
  const { t } = useTranslation('common')

  const handleClose = () => {
    setOpenCarbonReport(false)
  }

  return (
    <CModal alignment="center" visible={openCarbonReport} size="lg" onClose={handleClose}>
      <CModalBody className={styles.modalStyle}>
        <div className={styles.headerContainerDiv}>
          <div className={styles.headerTitleDiv}>
            <div>{t('reports.carbonEmissions.title')}</div>
            <IconButton title="Close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={styles.headerNameDiv}>{getAccountName(contactList, viewAccount)}</div>
        </div>
        <div className={styles.contentContainerDiv}>
          <CarbonEmissionComponent account={viewAccount} />
        </div>
      </CModalBody>
    </CModal>
  )
}

CarbonEmissionsReportComponent.defaultProps = {
  viewAccount: {},
  contactList: [],
  openCarbonReport: false,
  setOpenCarbonReport: noop,
}

CarbonEmissionsReportComponent.propTypes = {
  viewAccount: PropTypes.object,
  contactList: PropTypes.array,
  openCarbonReport: PropTypes.bool,
  setOpenCarbonReport: PropTypes.func,
}

export default CarbonEmissionsReportComponent
